export enum JoinNavigation {
    WELCOME = 'welcome',
    FAQPAGE = 'business-opportunity-faq',
    WHYFOREVER = 'whyforever',
    YOUROPPORTUNITY = 'your-opportunity',
    WHAT_IT_TAKES_TO_BE_A_FBO = 'what-it-takes-fbo'
}
